import React from 'react'
// Old API
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom'

// New API
// import { createRoot } from 'react-dom/client'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { datadogRum } from '@datadog/browser-rum'

import { msalConfig } from './config/msal.config'
import NextApp from './NextApp'
import packageJson from '../package.json'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister()
    }
  })
}

const {
  REACT_APP_DATADOG_RUM_ENV,
  REACT_APP_DATADOG_RUM_APP_ID,
  REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
  REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE
} = process.env

if (['dev', 'prd'].includes(REACT_APP_DATADOG_RUM_ENV)) {
  datadogRum.init({
    applicationId: REACT_APP_DATADOG_RUM_APP_ID,
    clientToken: REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'soyshare-web',
    env: REACT_APP_DATADOG_RUM_ENV,
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE || 20,
    trackUserInteractions: true,
    trackViewsManually: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
}
export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    console.log('initialize====> msalInstance.getActiveAccount()======>', msalInstance.getActiveAccount())
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
  }

  msalInstance.enableAccountStorageEvents()

  msalInstance.addEventCallback((event) => {
    console.log('addEventCallback======> event=======>', event)
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account
      console.log('addEventCallback======> login success=======>', account)
      msalInstance.setActiveAccount(account)
    } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
      msalInstance.setActiveAccount(null)
      console.log('addEventCallback======> logout success=======>')
    } else if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      const account = event.payload.account
      console.log('addEventCallback======> acquire token success=======>', account)
      msalInstance.setActiveAccount(account)
    } else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      console.log('addEventCallback======> acquire token failure=======>')
    }
  })
  // New API
  // const container = document.querySelector('#root')
  // const root = createRoot(container)
  // root.render(<NextApp />)

  /**
   * Old API
   * The old API is used here to maintain compatibility with Antd@3.
   * After upgrading to newer versions of Antd, this will be changed to the new API.
   */
  render(<NextApp msalInstance={msalInstance} />, document.getElementById('root'))
})
